import { createContext, useContext, useState } from 'react';
interface GuideContextType {
  currentStep: any;
  handleNextStep: (stepId: any) => void;
  handleResetStep: () => void;
  setDisabled: any;
  disabled: any;
}
const GuideContext = createContext<GuideContextType | undefined>(undefined);
export const GuideContextProvider = ({ children }: any) => {
  const guidance = sessionStorage.getItem('guidance');
  const businessType = sessionStorage.getItem('businessType');
  const [disabled, setDisabled] = useState(
    (guidance === 'started' || guidance === 'guidestarted') &&
      (location.pathname === '/dashboard' ||
        location.pathname === '/settings/faq' ||
        location.pathname === '/settings/integration')
  );
  const [currentStep, setCurrentStep] = useState(
    sessionStorage.getItem('GuidingStep')
      ? parseInt(sessionStorage.getItem('GuidingStep') ?? '0')
      : 0
  );
  //   const guidenceval = sessionStorage.getItem('guidance') === 'started' ? true : false;

  function handleNextStep(stepId: any) {
    setDisabled(
      sessionStorage.getItem('businessType') !== 'Retail' ||
        sessionStorage.getItem('guidance') === 'completed'
        ? false
        : true
    );
    const guidenceval = sessionStorage.getItem('guidance');
    if (guidenceval !== 'completed') {
      setCurrentStep(stepId);
      sessionStorage.setItem('GuidingStep', stepId.toString());
    }
  }
  function handleResetStep() {
    setCurrentStep(0);
    sessionStorage.setItem('GuidingStep', '0');
    setDisabled(false);
  }
  return (
    <GuideContext.Provider
      value={{ currentStep, handleNextStep, handleResetStep, setDisabled, disabled }}
    >
      {children}
    </GuideContext.Provider>
  );
};

export const useGuideContext = (): GuideContextType => {
  const Gcontext = useContext(GuideContext);
  if (!Gcontext) {
    throw new Error('useGuideContext must be used within a GuideContextProvider');
  }
  return Gcontext;
};
